import { lazy } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import SiteLayout from './components/site/SiteLayout'
import ScrollToTop from './components/ScrollToTop'
import './App.css'

// Eager load only the homepage for fast initial load
import Home from './pages/Home'

// Lazy load all other pages
const About = lazy(() => import('./pages/About'))
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'))
const TermsOfService = lazy(() => import('./pages/TermsOfService'))
const NotFound = lazy(() => import('./pages/NotFound'))
const Services = lazy(() => import('./pages/Services'))
const Workspace = lazy(() => import('./pages/Workspace'))
const Research = lazy(() => import('./pages/Research'))
const Notes = lazy(() => import('./pages/Notes'))
const Contact = lazy(() => import('./pages/Contact'))
const ServicePage = lazy(() => import('./components/site/ServicePage'))

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServicePage />} />
            <Route path="/workspace" element={<Workspace />} />
            <Route path="/workspace/:tab" element={<Workspace />} />
            <Route path="/research" element={<Research />} />
            <Route path="/notes" element={<Notes />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Router>
    </HelmetProvider>
  )
}

export default App
